var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPurplePhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3334 0.833344H6.66675C5.28341 0.833344 4.16675 1.95001 4.16675 3.33334V16.6667C4.16675 18.05 5.28341 19.1667 6.66675 19.1667H13.3334C14.7167 19.1667 15.8334 18.05 15.8334 16.6667V3.33334C15.8334 1.95001 14.7167 0.833344 13.3334 0.833344ZM14.1667 15H5.83341V3.33334H14.1667V15ZM8.33341 17.5H11.6667V16.6667H8.33341V17.5Z",
    fill: "#B6B0FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurplePhone);
export default __webpack_public_path__ + "static/media/purple-phone.f0a183115f61e9f969f42dedecc7708d.svg";
export { ForwardRef as ReactComponent };